import { IMAGE_URL } from '@app/constants/commonConstants';
export const imageData = {
  imageSrc: `${IMAGE_URL}CM20221107-53244-3d48a`,
  alt: '404_Illustration.png'
};

export const sms = {
  number: '+13098656129'
};
